module.exports = __webpack_public_path__ + "static/media/megaphone.5a75105a.svg";